import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import { AgGridTableWrapper } from '@mummssoftware/common-ui';

import 'ag-grid-community/dist/styles/ag-grid.css';
import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';

interface TableProps {
  frameworkComponents?: any;
  gridOptions?: any;
  rowData?: any;
  smallWidget?: any;
}

export const AgGridTable = ({
  frameworkComponents,
  gridOptions,
  rowData,
  smallWidget,
}: TableProps) => {
  const {
    props: { grid: gridTheme },
  } = useTheme() as any;

  return (
    <AgGridTableWrapper
      id="patients-listing-table-wrapper"
      className={`${gridTheme.className} light`}
    >
      <AgGridReact
        gridOptions={gridOptions}
        rowData={rowData || []}
        rowHeight={gridTheme.rowHeight}
        headerHeight={gridTheme.headerHeight}
        frameworkComponents={frameworkComponents}
      />
    </AgGridTableWrapper>
  );
};

export default AgGridTable;
